import { call, select, delay } from 'redux-saga/effects';
import getCardId from '../../../services/getCardId/getCardId';
import addCard from '../../cardManagment/addCard/addCard';
import removeIncomingCall from '../../callSessions/removeIncomingCall/removeIncomingCall';
import { selectConfig } from '../../../state/configs/configsSlice';
import { selectHeadsetType, selectYealinkDevice } from '../../../state/userMedia/userMediaSlice';
import { addAnsweredCall, isCallAnswered } from '../../../utils/devices';

export default function* acceptCall({ payload: { call: callSession } }) {
  if (callSession.status === 'ended') {
    // eslint-disable-next-line no-console
    console.warn('Can\'t accept call that has ended');
    yield call(removeIncomingCall, { payload: callSession.id });
    return;
  }
  // Check if this was answered via headset button (already in answered sessions)
  const wasAnsweredViaHeadset = isCallAnswered(callSession.id);

  // Add to answered calls BEFORE accepting/startCall to ensure proper tracking
  // This must happen before startCall() which triggers ongoingCalls events
  addAnsweredCall(callSession.id);

  callSession.accept();

  // Stop ringing on Yealink headset when call is accepted via UI
  // Skip this if answered via headset button to avoid conflicts
  if (!wasAnsweredViaHeadset) {
    try {
      const headsetType = yield select(selectHeadsetType);
      if (headsetType === 'yealink') {
        const callControl = yield select(selectYealinkDevice);
        if (callControl) {
          if (typeof callControl.startCall === 'function') {
            yield callControl.startCall();
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('acceptCall - Yealink startCall error:', error);
    }
  }

  const cardId = getCardId({ type: 'call' });

  if (!cardId) {
    yield call(addCard, { payload: { type: 'call' } });
  }

  yield call(removeIncomingCall, { payload: callSession.id });

  const popUrl = yield select((state) => selectConfig(state, 'PORTAL_AGENT_SCREEN_POP_URL'));
  if (popUrl && callSession.number.length >= 6) {
    const options = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=800,height=800';
    window.open(popUrl + callSession.number, '_blank', options);
  }

  yield delay(1000);
}
